/*jshint esversion: 6 */

export { default as NonFranchiseVehicleError } from './NonFranchiseVehicleError';
export { default as LoadingSpinner } from './LoadingSpinner';
export { default as StepBar } from './StepBar';
export { default as StepLink } from './StepLink';
export { default as CarNotFoundForm } from './CarNotFoundForm';
export { default as BookingOverview } from './BookingOverview';

export { default as YourSummary } from './Steps/YourSummary.vue';
export { default as FindMyCar } from './Steps/FindMyCar.vue';
export { default as ConfirmYourCar } from './Steps/ConfirmYourCar.vue';
export { default as SelectADealer } from './Steps/SelectADealer.vue';
export { default as SelectDateTime } from './Steps/SelectDateTime.vue';
export { default as ServiceOptions } from './Steps/ServiceOptions.vue';
export { default as AdditionalServices } from './Steps/AdditionalServices.vue';
export { default as Confirmation } from './Steps/Confirmation.vue';


// WEBPACK FOOTER //
// ./resources/assets/js/online-service-booking/components/index.js